export default "__VITE_ASSET__1fa75593__"